import { gql } from 'graphql-request'
import { graphQLClient } from '../../gqlClient'

export const getRangeFilterValues =
  (fieldName: string) =>
  async (): Promise<{ range_filter_values: Record<string, { min: number; max: number }> }> =>
    graphQLClient.request(gql`
  query Range_filter_values {
    range_filter_values {
      ${fieldName} {
        min
        max
      }
    }
  }
  `)
